// extracted by mini-css-extract-plugin
export default {"container":"YI","productarea":"ZI","btn":"aJ","promowrapper":"bJ","upsellarea":"cJ","subtitle":"eJ","system":"fJ","desc":"gJ","cardswrap":"hJ","cards":"iJ","squareloadingcontainer":"jJ","squareloading33":"kJ"};
    if(module.hot) {
      // 1738836197086
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  